import React, { Fragment } from "react";
import GetDocCards from "../api/GetDocCards";
import GetShipMethod from "../api/GetShipMethod";
import GetContactPerson from "../api/GetContactPerson";
import GetInvoiceAddress from "../api/GetInvoiceAddress";
import GetShipAddress from "../api/GetShipAddress";

class CardDetail extends React.Component {
  timer = null;
  state = {
    selectGroup: 0,
    error: "",
    protect: {
      detail: false,
      invoice: false,
      delivery: false,
    },
    cardNames: {
      loading: false,
      data: [],
      selected: null,
    },
    contactPerson: {
      loading: false,
      data: [],
      selected: null,
    },
    invoiceAddr: {
      loading: false,
      data: [],
      selected: null,
    },
    deliveryAddr: {
      loading: false,
      data: [],
      selected: null,
    },
    shipMethod: {
      loading: false,
      data: [],
      selected: null,
    },
    changeRetTransp: 0,
  };

  
  searchInvAddr = async (e) => {

    clearTimeout(this.timer);
    this.timer = setTimeout(async () => {
      this.setState({ invoiceAddr: { ...this.state.invoiceAddr, loading: true } });
      var _res = await GetInvoiceAddress({ ...this.props, query: e, CardCode: this.props.cardData?.CardCode });
      this.setState({
        invoiceAddr: { ...this.state.invoiceAddr, loading: false },
      });
      if (_res.status === 200) {
        if (_res.data.length > 0) {
          this.setState({
            invoiceAddr: {
              ...this.state.invoiceAddr,
              data: _res.data,
              loading: false,
            },
          });
        } else {
          this.setState({
            invoiceAddr: {
              ...this.state.invoiceAddr,
              data: [],
              loading: false,
            },
          });
        }
      }
    });
  };

  searchShipAddr = async (e) => {

    clearTimeout(this.timer);
    this.timer = setTimeout(async () => {
      this.setState({ deliveryAddr: { ...this.state.deliveryAddr, loading: true } });
      var _res = await GetShipAddress({ ...this.props, query: e, CardCode: this.props.cardData?.CardCode });
      this.setState({
        deliveryAddr: { ...this.state.deliveryAddr, loading: false },
      });
      if (_res.status === 200) {
        if (_res.data.length > 0) {
          this.setState({
            deliveryAddr: {
              ...this.state.deliveryAddr,
              data: _res.data,
              loading: false,
            },
          });
        } else {
          this.setState({
            deliveryAddr: {
              ...this.state.deliveryAddr,
              data: [],
              loading: false,
            },
          });
        }
      }
    });
  };

  searchContactPerson = async (e) => {

    clearTimeout(this.timer);
    this.timer = setTimeout(async () => {
      this.setState({ contactPerson: { ...this.state.contactPerson, loading: true } });
      var _res = await GetContactPerson({ ...this.props, query: e, CardCode: this.props.cardData?.CardCode });
      this.setState({
        contactPerson: { ...this.state.contactPerson, loading: false },
      });
      if (_res.status === 200) {
        if (_res.data.length > 0) {
          this.setState({
            contactPerson: {
              ...this.state.contactPerson,
              data: _res.data,
              loading: false,
            },
          });
        } else {
          this.setState({
            contactPerson: {
              ...this.state.contactPerson,
              data: [],
              loading: false,
            },
          });
        }
      }
    });
  };

  searchShipMethods = async (e) => {
    clearTimeout(this.timer);
    this.timer = setTimeout(async () => {
      this.setState({ shipMethod: { ...this.state.shipMethod, loading: true } });
      var _res = await GetShipMethod({ ...this.props, query: e });
      this.setState({
        shipMethod: { ...this.state.shipMethod, loading: false },
      });
      if (_res.status === 200) {
        if (_res.data.length > 0) {
          this.setState({
            shipMethod: {
              ...this.state.shipMethod,
              data: _res.data,
              loading: false,
            },
          });
        } else {
          this.setState({
            shipMethod: {
              ...this.state.shipMethod,
              data: [],
              loading: false,
            },
          });
        }
      }
    });
  };

  searchCardNames = async (e) => {
    clearTimeout(this.timer);
    this.timer = setTimeout(async () => {
      this.setState({ cardNames: { ...this.state.cardNames, loading: true } });
      var _res = await GetDocCards({ ...this.props, query: e });
      this.setState({ cardNames: { ...this.state.cardNames, loading: false } });
      if (_res.status === 200) {
        if (_res.data.length > 0) {
          this.setState({
            cardNames: {
              ...this.state.cardNames,
              data: _res.data,
              loading: false,
            },
          });
        } else {
          this.setState({
            cardNames: {
              ...this.state.cardNames,
              data: [],
              loading: false,
            },
          });
        }
      }
    });
  };

  render() {
    const {
      Bs,
      VARIANT,
      SIZE,
      close,
      open,
      cardData,
      change,
      countriesData,
      commChanel,
      setDetail,
      prepare
    } = this.props;

    try {
      /* Zákazník v SAPu */
      if (cardData?.CardCode !== "Z0000") {
        this.setState({
          protect: { detail: true, invoice: true, delivery: true },
        });
      }

      /* Go Digital */
      if (cardData?.CardCode === "Z3327") {
        this.setState({
          protect: { detail: true, invoice: true, delivery: false },
        });
      }

      /* Jednorázový zákazník a dobírky slovensko */
      if (cardData?.CardCode === "Z0000" || cardData?.CardCode === "Z2564") {
        this.setState({
          protect: { detail: false, invoice: false, delivery: false },
        });
      }
    } catch {}
      if (prepare) {
        setDetail();
        close();
      }
    return (
      <>
        <Bs
          modal
          show={open}
          onHide={close}
          keyboard={false}
          backdrop="static"
          centered
          size={SIZE.LG}
          aria-labelledby="contained-modal-title-vcenter"
        >
          <Bs modalheader closeButton>
            Zadat detaily zákazníka{" "}
            <Bs strong className="ms-4">
              {open && cardData?.CardName}
            </Bs>
          </Bs>
          <Bs alert variant={VARIANT.INFO}>
            <Bs small className="text-muted">
              Vyplň veškeré údaje o zákazníkovi a stiskni tlačítko uložit, které
              se nachází v dolní časti toho modulárního okna. Pokud se vše
              povede tak se okno zavře a bude možnost zadat nové zakázky. V
              opačném připadě ti pod tímto textem vyskočí další červeny pruh ve
              kterém uvidíš co je špatně.
            </Bs>
          </Bs>
          <Bs modalbody>
            {open && (
              <>
                <Bs row>
                  <Bs
                    nav
                    variant={VARIANT.TABS}
                    className="c-tab"
                    defaultActiveKey={this.state.selectGroup}
                  >
                    <Bs navitem>
                      <Bs
                        navlink
                        onClick={() => this.setState({ selectGroup: 0 })}
                        eventKey={0}
                      >
                        Základní údaje
                      </Bs>
                    </Bs>
                    <Bs navitem>
                      <Bs
                        navlink
                        onClick={() => this.setState({ selectGroup: 1 })}
                        eventKey={1}
                      >
                        {"Fakturační adresa " +
                          (cardData?.PaySameShip ? "= Dodací adresa" : "")}
                      </Bs>
                    </Bs>
                    {!cardData?.PaySameShip && (
                      <Bs navitem>
                        <Bs
                          navlink
                          disabled={cardData?.PaySameShip}
                          onClick={() => this.setState({ selectGroup: 2 })}
                          eventKey={2}
                        >
                          Dodací adresa
                        </Bs>
                      </Bs>
                    )}
                  </Bs>
                </Bs>
                <Bs row className="mt-4">
                  {/* Základní údaje */}
                  {this.state.selectGroup === 0 && (
                    <Bs row className="mb-2">
                      <Bs col lg={2} md={3} className="mb-2">
                        <Bs formtext>Zákazník kód</Bs>
                        <Bs formcontrol disabled value={cardData?.CardCode} />
                      </Bs>
                      <Bs col lg={5} md={8} className="mb-2">
                        <Bs formtext>Zákazník Název</Bs>
                        {cardData.CardName && this.state.protect.detail && (
                          <Bs
                            formcontrol
                            disabled={this.state.protect.detail}
                            value={cardData?.CardName}
                            onChange={(e) => {
                              change({
                                card: {
                                  ...cardData,
                                  CardName: e.target.value,
                                },
                              });
                            }}
                          />
                        )}
                        {!this.state.protect.detail && (
                          <Bs
                            formcontrol
                            disabled={this.state.protect.detail}
                            value={cardData?.CardName}
                            onChange={(e) => {
                              change({
                                card: {
                                  ...cardData,
                                  CardName: e.target.value
                                },
                              });
                            }}
                          />
                        )}
                        {!cardData.CardName && 0===1 && (
                          <Bs
                            brtxasyncselect
                            className="w-100"
                            isLoading={this.state.cardNames.loading}
                            disabled={
                              this.state.cardNames.loading ||
                              this.state.protect.detail
                            }
                            minLength={2}
                            allowNew
                            labelKey="CardName"
                            selected={this.state.cardNames.selected}
                            promptText="Pokud přestaneš psát tak se spustí vyhledávání..."
                            searchText="Hledám zákazníky v historii S21..."
                            emptyLabel="Nic jsem nenašel."
                            onChange={(e) => {
                              console.log(e);
                              this.setState({
                                cardNames: {
                                  ...this.state.cardNames,
                                  selected: e,
                                },
                              });
                              change({
                                card: {
                                  ...cardData,
                                  CardName: e[0].label,
                                },
                              });
                            }}
                            onSearch={this.searchCardNames}
                            options={this.state.cardNames.data}
                            placeholder={
                              !this.state.protect.detail ? "Začni psát" : ""
                            }
                            renderMenuItemChildren={(option, props) => (
                              <Fragment>
                                <Bs row>
                                  <Bs col xs={6}>
                                    <Bs strong>{option.CardName}</Bs>
                                  </Bs>
                                  <Bs col xs={6}>
                                    {option.CardIC}
                                  </Bs>
                                </Bs>
                                <Bs row>
                                  <Bs col xs={12}>
                                    {option.PayToStreet}, {option.PayToCity},{" "}
                                    {option.PayToZipCode}, {option.PayToCountry}
                                  </Bs>
                                  <Bs col xs={12}>
                                    {option.CntctEmail} / {option.CntctCellolar}
                                  </Bs>
                                </Bs>
                              </Fragment>
                            )}
                          />
                        )}
                      </Bs>
                      <Bs col lg={2} md={3} className="mb-2">
                        <Bs formtext>Země</Bs>
                        <Bs
                          formcontrol
                          disabled
                          value={cardData?.PayToCountry}
                        />
                      </Bs>
                      <Bs col lg={3} md={4} className="mb-2">
                        <Bs formtext>Komunikace</Bs>
                        <Bs
                          brtxselect
                          isClearable
                          options={commChanel}
                          placeholder={"Vyber"}
                          value={commChanel.filter(
                            (f) => f.value === cardData?.CommChannel
                          )}
                          onChange={(e) =>
                            change({
                              card: {
                                ...cardData,
                                CommChannel: e?.value,
                              },
                            })
                          }
                        />
                      </Bs>
                      <Bs col lg={4} md={6} className="mb-2">
                        <Bs formtext>IČO</Bs>
                        <Bs
                          formcontrol
                          disabled={this.state.protect.detail}
                          value={cardData?.CardICO}
                          onChange={(e) =>
                            change({
                              card: {
                                ...cardData,
                                CardIC: e.target.value,
                              },
                            })
                          }
                        />
                      </Bs>
                      <Bs col lg={4} md={6} className="mb-2">
                        <Bs formtext>DIČ</Bs>
                        <Bs
                          formcontrol
                          disabled={this.state.protect.detail}
                          value={cardData?.CardDIC}
                          onChange={(e) =>
                            change({
                              card: {
                                ...cardData,
                                CardDIC: e.target.value,
                              },
                            })
                          }
                        />
                      </Bs>
                      <Bs col lg={4} md={6} className="mb-2">
                        <Bs formtext>Měna</Bs>
                        <Bs
                          formcontrol
                          disabled={true}
                          value={cardData?.CurrCode}
                          onChange={(e) =>
                            change({
                              card: {
                                ...cardData,
                                CurrCode: e.target.value,
                              },
                            })
                          }
                        />
                      </Bs>
                      <Bs col lg={4} md={6} className="mb-2">
                        <Bs formtext>Kontaktní osoba</Bs>
                        {!cardData?.CntctCode && (
                          <Bs
                          brtxasyncselect
                          className="w-100"
                          isLoading={this.state.contactPerson.loading}
                          disabled={
                            this.state.contactPerson.loading ||
                            !this.state.protect.detail
                          }
                          minLength={1}
                          selected={this.state.contactPerson.selected}
                          promptText="Pokud přestaneš psát tak se spustí vyhledávání..."
                          searchText="Hledám kontaktní osoby..."
                          emptyLabel="Nic jsem nenašel."
                          onChange={(e) => {
                            this.setState({
                              contactPerson: {
                                ...this.state.contactPerson,
                                selected: e,
                              },
                            })
                            change({
                              card: {
                                ...cardData,
                                ...e[0]
                              },
                            })
                          }}
                          onSearch={this.searchContactPerson}
                          options={this.state.contactPerson.data}
                          placeholder={
                            this.state.protect.detail ? "Začni psát" : ""
                          }
                          renderMenuItemChildren={(option, props) => (
                            <Fragment>{option.label}</Fragment>
                          )}
                        />
                        )}
                        {cardData?.CntctCode && (
                          <Bs
                          brtxselect
                          isClearable
                          value={{
                            value: cardData?.CntctCode,
                            label: cardData?.label,
                          }}
                          onChange={(e) => {
                            this.setState({
                              contactPerson: {
                                ...this.state.contactPerson,
                                selected: null,
                              },
                            })
                            change({
                              card: {
                                ...cardData,
                                CntctCode:null,
                                CntctCellolar: null
                              },
                            })
                          }}
                        />
                        )}
                        
                      </Bs>
                      <Bs col lg={4} md={6} className="mb-2">
                        <Bs formtext>Email</Bs>
                        <Bs
                          formcontrol
                          value={cardData?.CntctEmail}
                          onChange={(e) =>
                            change({
                              card: {
                                ...cardData,
                                CntctEmail: e.target.value,
                              },
                            })
                          }
                        />
                      </Bs>
                      <Bs col lg={4} md={6} className="mb-2">
                        <Bs formtext>Mobilní telefon</Bs>
                        <Bs
                          formcontrol
                          disabled={this.state.protect.detail}
                          value={cardData?.CntctCellolar}
                          onChange={(e) =>
                            change({
                              card: {
                                ...cardData,
                                CntctCellolar: e.target.value,
                              },
                            })
                          }
                        />
                      </Bs>
                      <Bs col lg={4} md={6} className="mb-2">
                        <Bs formtext>Jak vrátit</Bs>
                        {cardData?.RetTranspCode && (
                          <Bs
                            brtxselect
                            isClearable
                            value={{
                              value: cardData?.RetTranspCode,
                              label: cardData?.RetTranspCode,
                            }}
                            onChange={(e) =>
                              change({
                                card: {
                                  ...cardData,
                                  RetTranspCode: e?.value,
                                },
                              })
                            }
                          />
                        )}
                        {!cardData?.RetTranspCode && (
                          <Bs
                            brtxasyncselect
                            className="w-100"
                            isLoading={this.state.shipMethod.loading}
                            disabled={this.state.shipMethod.loading}
                            minLength={3}
                            selected={this.state.shipMethod.selected}
                            promptText="Pokud přestaneš psát tak se spustí vyhledávání..."
                            searchText="Hledám dopravy na vrácení zásilky..."
                            emptyLabel="Nic jsem nenašel."
                            onChange={(e) =>
                              change({
                                card: {
                                  ...cardData,
                                  RetTranspCode: e[0].value,
                                },
                              })
                            }
                            onSearch={this.searchShipMethods}
                            options={this.state.shipMethod.data}
                            placeholder={
                              this.state.protect.detail ? "Začni psát" : ""
                            }
                            renderMenuItemChildren={(option, props) => (
                              <Fragment>
                                <Bs row>
                                  <Bs col xs={12}>
                                    <Bs strong>{option.label}</Bs>
                                  </Bs>
                                </Bs>
                                <Bs row>
                                  <Bs col xs={12}>
                                    <Bs small className="text-muted">
                                      {option.ItemName}
                                    </Bs>
                                  </Bs>
                                </Bs>
                              </Fragment>
                            )}
                          />
                        )}
                      </Bs>
                    </Bs>
                  )}
                  {/* Fakturační adresa */}
                  {this.state.selectGroup === 1 && (
                    <>
                      <Bs row>
                        <Bs col lg={4} md={6} className="mb-2">
                          <Bs formtext>Fakturační = dodací</Bs>
                          <Bs
                            formswitch
                            checked={cardData?.PaySameShip}
                            onChange={(e) =>
                              change({
                                card: {
                                  ...cardData,
                                  PaySameShip: e.target.checked,
                                  ShipToCity: null,
                                  ShipToCountry: null,
                                  ShipToStreet:null,
                                  ShipToWorkplace: null,
                                  ShipToZipCode:null
                                },
                              })
                            }
                          />
                        </Bs>
                      </Bs>

                      <Bs col lg={4} md={6} className="mb-2">
                        <Bs formtext>Adresa</Bs>
                        {!cardData?.PayToCode && (
                          <Bs
                            brtxasyncselect
                            className="w-100"
                            isLoading={this.state.invoiceAddr.loading}
                            disabled={
                              this.state.invoiceAddr.loading ||
                              !this.state.protect.invoice
                            }
                            minLength={1}
                            selected={this.state.invoiceAddr.selected}
                            promptText="Pokud přestaneš psát tak se spustí vyhledávání..."
                            searchText="Hledám fakturační adresy..."
                            emptyLabel="Nic jsem nenašel."
                            labelKey="PayToCode"
                            onChange={(e) => {
                              this.setState({
                                invoiceAddr: {
                                  ...this.state.invoiceAddr,
                                  selected: e,
                                },
                              })
                              change({
                                card: {
                                  ...cardData,
                                  ...e[0],
                                },
                              })
                            }
                              
                            }
                            onSearch={this.searchInvAddr}
                            options={this.state.invoiceAddr.data}
                            placeholder={
                              this.state.protect.invoice ? "Začni psát" : ""
                            }
                            renderMenuItemChildren={(option, props) => (
                              <Fragment>{option.PayToCode}</Fragment>
                            )}
                          />
                        )}
                        {cardData?.PayToCode && (
                          <Bs
                            brtxselect
                            isClearable={true}
                            options={null}
                            onChange={(e) => {
                              change({
                                card: {
                                  ...cardData,
                                  PayToCode: e?.value,
                                  PayToCity: null,
                                  PayToCountry: null,
                                  PayToStreet:null,
                                  PayToWorplace: null,
                                  PayToZipCode: null
                                },
                              });
                              this.setState({
                                invoiceAddr: {
                                  ...this.state.invoiceAddr,
                                  selected: null,
                                },
                              })
                            }}
                            value={{
                              value: cardData?.PayToCode,
                              label: cardData?.PayToCode,
                            }}
                          />
                        )}
                      </Bs>
                      <Bs col lg={4} md={6} className="mb-2">
                        <Bs formtext>Ulice</Bs>
                        <Bs
                          formcontrol
                          disabled={this.state.protect.invoice}
                          value={cardData?.PayToStreet}
                          onChange={(e) =>
                            change({
                              card: {
                                ...cardData,
                                PayToStreet: e.target.value
                              },
                            })
                          }
                        />
                      </Bs>
                      <Bs col lg={4} md={6} className="mb-2">
                        <Bs formtext>Město</Bs>
                        <Bs
                          formcontrol
                          disabled={this.state.protect.invoice}
                          value={cardData?.PayToCity}
                          onChange={(e) =>
                            change({
                              card: {
                                ...cardData,
                                PayToCity: e.target.value
                              },
                            })
                          }
                        />
                      </Bs>
                      <Bs col lg={4} md={6} className="mb-2">
                        <Bs formtext>PSČ</Bs>
                        <Bs
                          formcontrol
                          disabled={this.state.protect.invoice}
                          value={cardData?.PayToZipCode}
                          onChange={(e) =>
                            change({
                              card: {
                                ...cardData,
                                PayToZipCode: e.target.value
                              },
                            })
                          }
                        />
                      </Bs>
                      <Bs col lg={4} md={6} className="mb-2">
                        <Bs formtext>Stát</Bs>
                        <Bs
                          brtxselect
                          isDisabled={this.state.protect.invoice}
                          options={countriesData}
                          placeholder={"Vyber"}
                          value={
                            countriesData.filter(
                              (f) => f.value === cardData?.PayToCountry
                            )[0]
                          }
                          onChange={(e) => change({
                            card: {
                              ...cardData,
                              PayToCountry: e.value
                            },
                          })}
                        />
                      </Bs>
                      <Bs col lg={4} md={6} className="mb-2">
                        <Bs formtext>Provozovna</Bs>
                        <Bs
                          formcontrol
                          disabled={this.state.protect.invoice}
                          value={cardData?.PayToWorplace}
                          onChange={(e) =>
                            change({
                              card: {
                                ...cardData,
                                PayToWorplace: e.target.value
                              },
                            })
                          }
                        />
                      </Bs>
                    </>
                  )}
                  {/* Dodací adresa */}
                  {this.state.selectGroup === 2 && (
                    <>
                      <Bs col lg={4} md={6} className="mb-2">
                        <Bs formtext>Adresa</Bs>
                        {!cardData?.ShipToCode && (
                          <Bs
                            brtxasyncselect
                            className="w-100"
                            isLoading={this.state.deliveryAddr.loading}
                            disabled={
                              this.state.deliveryAddr.loading ||
                              !this.state.protect.invoice
                            }
                            minLength={1}
                            selected={this.state.deliveryAddr.selected}
                            promptText="Pokud přestaneš psát tak se spustí vyhledávání..."
                            searchText="Hledám doručovací adresy..."
                            emptyLabel="Nic jsem nenašel."
                            labelKey="ShipToCode"
                            onChange={(e) => {
                              this.setState({
                                deliveryAddr: {
                                  ...this.state.deliveryAddr,
                                  selected: e,
                                },
                              })
                              change({
                                card: {
                                  ...cardData,
                                  ...e[0],
                                },
                              })
                            }}
                            onSearch={this.searchShipAddr}
                            options={this.state.deliveryAddr.data}
                            placeholder={
                              this.state.protect.invoice ? "Začni psát" : ""
                            }
                            renderMenuItemChildren={(option, props) => (
                              <Fragment>{option.ShipToCode}</Fragment>
                            )}
                          />
                        )}
                        {cardData?.ShipToCode && (
                          <Bs
                            brtxselect
                            isClearable={true}
                            options={null}
                            onChange={(e) => {
                              this.setState({
                                deliveryAddr: {
                                  ...this.state.deliveryAddr,
                                  selected: null,
                                },
                              })
                              change({
                                card: {
                                  ...cardData,
                                  ShipToCode: e?.value,
                                  ShipToCity: null,
                                  ShipToCountry: null,
                                  ShipToStreet:null,
                                  ShipToWorplace: null,
                                  ShipToZipCode: null
                                },
                              });
                            }}
                            value={{
                              value: cardData?.ShipToCode,
                              label: cardData?.ShipToCode,
                            }}
                          />
                        )}
                      </Bs>
                      <Bs col lg={4} md={6} className="mb-2">
                        <Bs formtext>Ulice</Bs>
                        <Bs
                          formcontrol
                          disabled={this.state.protect.delivery}
                          value={cardData?.ShipToStreet}
                          onChange={(e) =>
                            change({
                              card: {
                                ...cardData,
                                ShipToStreet: e.target.value
                              },
                            })
                          }
                        />
                      </Bs>
                      <Bs col lg={4} md={6} className="mb-2">
                        <Bs formtext>Město</Bs>
                        <Bs
                          formcontrol
                          disabled={this.state.protect.delivery}
                          value={cardData?.ShipToCity}
                          onChange={(e) =>
                            change({
                              card: {
                                ...cardData,
                                ShipToCity: e.target.value
                              },
                            })
                          }
                        />
                      </Bs>
                      <Bs col lg={4} md={6} className="mb-2">
                        <Bs formtext>PSČ</Bs>
                        <Bs
                          formcontrol
                          disabled={this.state.protect.delivery}
                          value={cardData?.ShipToZipCode}
                          onChange={(e) =>
                            change({
                              card: {
                                ...cardData,
                                ShipToZipCode: e.target.value
                              },
                            })
                          }
                        />
                      </Bs>
                      <Bs col lg={4} md={6} className="mb-2">
                        <Bs formtext>Stát</Bs>
                        <Bs
                          brtxselect
                          isDisabled={this.state.protect.delivery}
                          options={countriesData}
                          placeholder={"Vyber"}
                          value={countriesData.filter(f => f.value === cardData?.ShipToCountry)[0]}
                          onChange={(e) => change({
                            card: {
                              ...cardData,
                              ShipToCountry: e.value
                            },
                          })}
                        />
                      </Bs>
                      <Bs col lg={4} md={6} className="mb-2">
                        <Bs formtext>Provozovna</Bs>
                        <Bs
                          formcontrol
                          disabled={this.state.protect.delivery}
                          value={cardData?.ShipToWorkplace}
                          onChange={(e) => change({
                            card: {
                              ...cardData,
                              ShipToWorkplace: e.target.value
                            },
                          })}
                        />
                      </Bs>
                    </>
                  )}
                </Bs>
              </>
            )}
          </Bs>
          <Bs modalfooter>
            <Bs row>
              <Bs col className="d-flex justify-content-end">
                <Bs
                  button
                  size={SIZE.SM}
                  variant={VARIANT.SUCCESS}
                  onClick={() => {
                    setDetail();
                    close();
                  }}
                >
                  Uložit
                </Bs>
              </Bs>
            </Bs>
          </Bs>
        </Bs>
      </>
    );
  }
}

export default CardDetail;
